import { YourGlassRepairsForm } from "./Form";
import useYourGlassRepairs from "./hooks/useYourGlassRepairs";

export const YourGlassRepairs = () => {
  const props = useYourGlassRepairs();
  return <YourGlassRepairsForm {...props} />;
};

export default YourGlassRepairs;
